import { get_padding2xbtedaunn69u as get_padding } from '../Element.ext.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../models/data.mjs';
import { minOf33o15vox9quzb as minOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { ContainerElementjaaooy2agvhc as ContainerElement } from '../Element.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_spacingForChildCornerRadii() {
  var tmp0_elvis_lhs = get_padding(this);
  var tmp;
  var tmp_0 = tmp0_elvis_lhs;
  if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
    tmp = this.get_themeAndBack_k3yag2_k$().theme_1.padding_1.top_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var pad = tmp;
  var tmp1_elvis_lhs = this.get_gap_83dt6d_k$();
  var tmp_1;
  var tmp_2 = tmp1_elvis_lhs;
  if ((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null) {
    tmp_1 = this.get_themeAndBack_k3yag2_k$().theme_1.gap_1;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var gap = tmp_1;
  return minOf(new (Dimension())(pad), new (Dimension())(gap)).value_1;
}
var LinearLayoutElementClass;
function LinearLayoutElement() {
  if (LinearLayoutElementClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'LinearLayoutElement', VOID, VOID, [ContainerElement()]);
    LinearLayoutElementClass = $;
  }
  return LinearLayoutElementClass;
}
//region block: exports
export {
  get_spacingForChildCornerRadii as get_spacingForChildCornerRadii2ikrz4gsg7d4b,
  LinearLayoutElement as LinearLayoutElement3ltvobok1lxtu,
};
//endregion

//# sourceMappingURL=LinearLayouts.mjs.map
